import homepageHeroSrc from '@images/marketing/Home-Hero.jpg';
import homepageHeroMobileSrc from '@images/marketing/Home-Hero_Mobile.jpg';
export var homepageHeroContent = {
    headline: 'Say Bye to Boring Dog Food',
    heroImage: {
        src: homepageHeroSrc,
        alt: 'Beagle eating NomNomNow from a bowl',
    },
    heroImageMobile: {
        src: homepageHeroMobileSrc,
        alt: 'Beagle eating NomNomNow from a bowl',
    },
    ctaUrl: '/profile',
};
